import { Switch, useRouteMatch } from "react-router-dom";
import ProtectedRoute from "components/ProtectedRoutes";

import Affiliates from "./Affiliates";
import AffiliateRules from "./AffiliateRules";
import ViewAffiliates from "./ViewAffiliates";
import AffiliateLeaderboard from "./AffiliateLeaderboard";
import RewardHistoryEarnings from "./RewardHistoryEarnings";
import RewardHistoryCoinDetail from "./RewardHistoryCoinDetail";
import RewardHistoryEarningDetails from "./RewardHistoryEarningDetails";
import InviteHistoryAffiliateDetails from "./InviteHistoryAffiliateDetails";

export default function AffiliatesIndex() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <ProtectedRoute exact path={path} component={Affiliates} />
      <ProtectedRoute path={`${path}/rules`} component={AffiliateRules} />
      <ProtectedRoute
        path={`${path}/leaderboard`}
        component={AffiliateLeaderboard}
      />
      <ProtectedRoute
        path={`${path}/rewards/:coin`}
        component={RewardHistoryCoinDetail}
      />
      <ProtectedRoute
        path={`${path}/invites/:id/`}
        component={InviteHistoryAffiliateDetails}
      />
      <ProtectedRoute path={`${path}/view`} component={ViewAffiliates} />

      <ProtectedRoute
        path={`${path}/earnings/:id`}
        component={RewardHistoryEarningDetails}
      />

      <ProtectedRoute
        path={`${path}/earnings`}
        component={RewardHistoryEarnings}
      />
    </Switch>
  );
}
